type PlacementPossibilityDecider = (
  elementToBePlacedBox: DOMRect,
  referenceBox: DOMRect
) => boolean;

type PlacementValueGetter = (
  elementToBePlacedBox: DOMRect,
  referenceBox: DOMRect
) => number;

const MARGIN = 4;

const isLeftPlacementPossible: PlacementPossibilityDecider = (
  elementToBePlacedBox,
  referenceBox
) => {
  return window.innerWidth > referenceBox.left + elementToBePlacedBox.width;
};

const isBottomPlacementPossible: PlacementPossibilityDecider = (
  elementToBePlacedBox,
  referenceBox
) => {
  return (
    window.innerHeight >
    referenceBox.bottom + elementToBePlacedBox.height + MARGIN
  );
};

const getLeft: PlacementValueGetter = (elementToBePlacedBox, referenceBox) => {
  return isLeftPlacementPossible(elementToBePlacedBox, referenceBox)
    ? referenceBox.left
    : referenceBox.right - elementToBePlacedBox.width;
};

const getTop: PlacementValueGetter = (elementToBePlacedBox, referenceBox) => {
  return isBottomPlacementPossible(elementToBePlacedBox, referenceBox)
    ? referenceBox.bottom + MARGIN
    : referenceBox.top - elementToBePlacedBox.height - MARGIN;
};

export function getDefaultOffscreenPlacement() {
  return {
    left: -1000,
    top: -1000,
  };
}

export function getRelativePlacementCSS(
  elementToBePlacedBox: DOMRect,
  referenceBox: DOMRect
) {
  return {
    left: getLeft(elementToBePlacedBox, referenceBox),
    top: getTop(elementToBePlacedBox, referenceBox),
  };
}
